import { Pipe, PipeTransform } from '@angular/core';

import { UtilitiesService } from 'app/services/utilities/utilities.service';

@Pipe({
  name: 'commaCurrency'
})
export class CommaCurrencyPipe implements PipeTransform {

  constructor(private utilitiesService: UtilitiesService) {}

  transform(value: any, args?: any): any {
    return this.utilitiesService.commaSeparateNumber(value);
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/comma-currency.pipe.ts